var render = function render(){
  var _vm$actions;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "placeholder d-flex",
    "class": _vm.rootClasses,
    style: {
      minHeight: "".concat(_vm.effectiveMinHeight, "px")
    }
  }, [_c('div', {
    staticClass: "placeholder__inner d-flex align-center",
    "class": _vm.innerClasses
  }, [_c('div', {
    staticClass: "placeholder__content",
    "class": _vm.contentClasses
  }, [!_vm.isBanner ? _c('div', {
    staticClass: "placeholder__icon-wrap d-flex justify-center w-100"
  }, [_vm._t("illustration", function () {
    return [_c('MasterSvg', {
      staticClass: "placeholder__icon flex-shrink-0",
      attrs: {
        "use": _vm.icon,
        "width": _vm.iconWidth
      }
    })];
  })], 2) : _c('MasterSvg', {
    staticClass: "placeholder__icon flex-shrink-0",
    attrs: {
      "use": _vm.icon,
      "width": _vm.iconWidth
    }
  }), _c('div', {
    staticClass: "placeholder__text",
    "class": {
      'flex-grow-1': _vm.isBanner
    }
  }, [_vm.title ? _c('div', {
    staticClass: "placeholder--title"
  }, [_vm._v(" " + _vm._s(_vm.title) + " ")]) : _vm._e(), _vm.description || _vm.actions ? _c('div', {
    staticClass: "placeholder__meta d-flex text-caption text-gs-semibold",
    "class": _vm.metaClasses
  }, [_vm.description ? _c('span', {
    staticClass: "placeholder--description",
    domProps: {
      "innerHTML": _vm._s(_vm.description)
    }
  }) : _vm._e(), (_vm$actions = _vm.actions) !== null && _vm$actions !== void 0 && _vm$actions.length ? _c('div', {
    staticClass: "placeholder--actions d-flex",
    "class": _vm.actionsClasses
  }, _vm._l(_vm.displayActions, function (action) {
    return _c('v-btn', {
      key: action.action,
      "class": [{
        primary: action.main,
        'mt-0 ml-3': _vm.isBanner,
        'mt-4': !_vm.isBanner
      }, action["class"]],
      attrs: {
        "disabled": action.disabled,
        "loading": action.loading,
        "small": action.size === 'small',
        "x-small": action.size === 'x-small',
        "text": action.type == 'text' || !action.main
      },
      on: {
        "click": function click($event) {
          return _vm.onAction(action);
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "icon": action.icon ? _vm.iconName(action.icon) : null
      }
    }), _c('span', [_vm._v(_vm._s(action.text))])], 1);
  }), 1) : _vm._e()]) : _vm._e(), _c('div', {
    staticClass: "d-flex",
    "class": {
      'justify-center': !_vm.isBanner
    }
  }, [_vm._t("default")], 2)])], 1)])]);

}
var staticRenderFns = []

export { render, staticRenderFns }